import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriorityComponent } from './priority/priority.component';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule, MatIconModule, MatSelectModule, MatTooltipModule } from '@angular/material';
import { ProjectsService } from './projects/projects.service';
import { ReactiveFormsModule } from '@angular/forms';
import { UsersComponent } from './users/users.component';
import { UsersService } from './users/users.service';
import { MessagesComponent } from './messages/messages.component';
import { MessagesRowComponent } from './messages/messages-row/messages-row.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ReceiveIncomingCallAgentsOnlineComponent } from './receive-incoming-call-agents-online/receive-incoming-call-agents-online.component';
import { CascadingComponent } from './receive-incoming-call-agents-online/cascading/cascading.component';
import { LongestIdleComponent } from './receive-incoming-call-agents-online/longest-idle/longest-idle.component';
import { SimultaneousCallsComponent } from './receive-incoming-call-agents-online/simultaneous-calls/simultaneous-calls.component';
import { RandomCascadeComponent } from './receive-incoming-call-agents-online/random-cascade/random-cascade.component';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { AssignProjectsComponent } from './assign-projects/assign-projects.component';
import { LabelUpdaterComponent } from './label-updater/label-updater.component';
import { MatInputModule } from '@angular/material';
import { NgxPermissionsModule } from 'ngx-permissions';
import { RouterModule } from '@angular/router';
import { phoneNumbersRoutes } from './phone-numbers.routes';
import { PhoneNumbersComponent } from './phone-numbers.component';
import { PhoneNumbersService } from './phone-numbers.service';
import { PhoneNumberSettingsComponent } from './phone-number-settings/phone-number-settings.component';
import { CustomPhoneNumberComponent } from './custom-phone-number/custom-phone-number.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule,
    TranslateModule,
    MatSelectModule,
    MatIconModule,
    ReactiveFormsModule,
    UiSwitchModule,
    MatCheckboxModule,
    MatTooltipModule,
    NgxDnDModule,
    MatInputModule,
    NgxPermissionsModule,
    RouterModule.forChild(phoneNumbersRoutes)
  ],
  declarations: [
    PriorityComponent,
    UsersComponent,
    MessagesComponent,
    MessagesRowComponent,
    ReceiveIncomingCallAgentsOnlineComponent,
    CascadingComponent,
    LongestIdleComponent,
    SimultaneousCallsComponent,
    RandomCascadeComponent,
    AssignProjectsComponent,
    LabelUpdaterComponent,
    PhoneNumbersComponent,
    PhoneNumberSettingsComponent,
    CustomPhoneNumberComponent
  ],
  providers: [ProjectsService, UsersService, PhoneNumbersService],
  exports: [PriorityComponent, UsersComponent, MessagesComponent, ReceiveIncomingCallAgentsOnlineComponent],
  entryComponents: [
    PriorityComponent,
    UsersComponent,
    MessagesComponent,
    ReceiveIncomingCallAgentsOnlineComponent,
    AssignProjectsComponent,
    LabelUpdaterComponent
  ]
})
export class PhoneNumbersModule {}
